import { Component } from '@angular/core';

@Component({
  selector: 'app-tc-home',
  templateUrl: './tc-home.component.html',
  styleUrls: ['./tc-home.component.scss']
})
export class TcHomeComponent {

}
